import { Component, OnInit } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { SaveFormService } from "../services/save-form.service";

@Component({
	selector: "app-address-company",
	templateUrl: "./address-company.component.html",
	styleUrls: ["./address-company.component.scss"],
})
export class AddressCompanyComponent implements OnInit {
	form!: FormGroup;

	index = "";
	city = "";
	area = "";
	street = "";
	house = "";
	office = "";

	constructor(
		private router: Router,
		private translateService: TranslateService,
		private saveFormService: SaveFormService
	) {}

	ngOnInit() {
		this.initForm();
	}

	initForm(): void {
		if (localStorage.hasOwnProperty("form")) {
			this.index = this.saveFormService.getFormData().companyAddress.index;
			this.city = this.saveFormService.getFormData().companyAddress.city;
			this.area = this.saveFormService.getFormData().companyAddress.area;
			this.street = this.saveFormService.getFormData().companyAddress.street;
			this.house = this.saveFormService.getFormData().companyAddress.house;
			this.office = this.saveFormService.getFormData().companyAddress.office;
		} else {
			this.saveFormService.initFormLocalStorage();
		}

		this.form = new FormGroup({
			indexFormControl: new FormControl(this.index, [Validators.required, Validators.minLength(6)]),
			cityFormControl: new FormControl(this.city, [Validators.required]),
			areaFormControl: new FormControl(this.area, [Validators.required]),
			streetFormControl: new FormControl(this.street, [Validators.required]),
			houseFormControl: new FormControl(this.house, [Validators.required]),
			officeFormControl: new FormControl(this.office, [Validators.required]),
		});
	}

	get indexRequiredError() {
		return this.form.get("indexFormControl")?.hasError("required");
	}

	get indexFormatError() {
		return this.form.get("indexFormControl")?.hasError("minlength");
	}

	get cityRequiredError() {
		return this.form.get("cityFormControl")?.hasError("required");
	}

	get areaRequiredError() {
		return this.form.get("cityFormControl")?.hasError("required");
	}

	get streetRequiredError() {
		return this.form.get("cityFormControl")?.hasError("required");
	}

	get houseRequiredError() {
		return this.form.get("houseFormControl")?.hasError("required");
	}

	get officeRequiredError() {
		return this.form.get("officeFormControl")?.hasError("required");
	}

	saveData() {
		const index = this.form.get("indexFormControl")?.value.trim();
		const city = this.form.get("cityFormControl")?.value.trim();
		const area = this.form.get("areaFormControl")?.value.trim();
		const street = this.form.get("streetFormControl")?.value.trim();
		const house = this.form.get("houseFormControl")?.value.trim();
		const office = this.form.get("officeFormControl")?.value.trim();

		this.saveFormService.saveCompanyAddress(index, city, area, street, house, office);
	}

	sendForm() {
		this.router.navigate(["/register/products"]);
	}
}
